import React, { Component } from 'react';
import { Route } from 'react-router-dom';
import { getLanguage } from "../../store/rootReducer";
import { connect } from 'react-redux';


class PrivateRoute extends Component {

    render() {
        const { component: Component, ...rest } = this.props;

        const renderRoute = props => {

            return (
                <Component {...props} />
            );
        };

        return (
            <Route {...rest} render={renderRoute} />
        );
    }
}

const mapStateToProps = (state) => {
  return {
    language: getLanguage(state)
  }
};

export default connect(
    mapStateToProps
)(PrivateRoute);